import { FilterSegmentSelectInputOption, FilterSelectLabel } from './FilterInputsList.types';

export const createFilterSelectOption = (
  value: string,
  label: FilterSelectLabel,
  additionalProps: Omit<FilterSegmentSelectInputOption, 'value' | 'label' | 'id'> = {},
) => ({
  id: value,
  value,
  label,
  labelInMenu: label,
  labelInTriggerButton: label,
  ...additionalProps,
});

/**
 * Returns the string to be displayed in the trigger button of a select menu in the filter input
 *
 * No items selected: renders placeholder
 * 1 item selected: renders item name
 * 2 items selected: renders "<item 1> or <item 2>"
 * 3+ items selected: renders "<item count> selected"
 */
export const getFilterSegmentSelectInputTriggerText = (
  selectedOptions: FilterSegmentSelectInputOption[] = [],
  placeholder: string,
) => {
  const missingLabelsInSelectedOptions = selectedOptions?.every(
    (s) => s?.labelInTriggerButton === undefined,
  );
  if (!missingLabelsInSelectedOptions && selectedOptions.length === 1) {
    return selectedOptions[0].labelInTriggerButton;
  } else if (!missingLabelsInSelectedOptions && selectedOptions.length > 1) {
    return selectedOptions.length === 2
      ? `${selectedOptions[0].labelInTriggerButton} or ${selectedOptions[1].labelInTriggerButton}`
      : `${selectedOptions.length} selected`;
  }
  return placeholder;
};
